import type { AttentionItem } from '@@/api/attention/attention-items';
import { useQuery } from '@tanstack/react-query';
import { useClient } from 'hooks/useClient';

/**
 * Matches the cron cadence that produces most of the underlying signals.
 * Polling faster buys nothing because nothing changes between runs.
 */
const POLL_INTERVAL = 60_000;

export const useAttention = (websiteId: number | undefined) => {
  const client = useClient();

  const { data, isLoading, isError } = useQuery<{ items: AttentionItem[] }>({
    queryKey: ['ATTENTION', websiteId],
    queryFn: () => client.get<{ items: AttentionItem[] }>(`/attention/${websiteId}`),
    refetchInterval: POLL_INTERVAL,
    refetchOnWindowFocus: true,
    enabled: !!websiteId,
  });

  // isError is what stops a failed fetch reading as "nothing needs you": the query
  // is gated on websiteId, so react-query reports isLoading false and items empty
  // for a prerequisite miss, a failure and a genuine all-clear alike.
  return { items: data?.items ?? [], isLoading, isError };
};
